import React, { useEffect, useState } from 'react';

// Components
import * as S from './Styled';
import CountryFlag from '../CountryFlag';
import Spinner from '../Spinner';
import Volume from './Volume';
import FormButtons from './FormButtons';
import FormDropdown from './FormDropdown';

// Store
import { useSelector } from 'react-redux';

//Utils
import api from '../../api';
import _find from 'lodash/find';
import { useTranslation } from 'react-i18next';
import * as Label from '../Label';
import { useLang } from '../../context/lang';

const Single = ({ initialItemId }) => {
  const [item, setItem] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const location = useSelector(state => state.user.location);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { t } = useTranslation();
  const { language } = useLang();

  useEffect(() => {
    const loadItem = async () => {
      try {
        let { data } = await api.get(`/products/${initialItemId}`, {
          params: {
            latitude: location ? location.latitude : null,
            longitude: location ? location.longitude : null,
          },
        });

        if (data.online_price === null) data.online_price = 0;
        if (data.drugstore_price === null) data.drugstore_price = 0;

        setItem(data);
        setLoading(false);
      } catch (e) {
        //Keep in mind that error responses handled by axios inter
        console.error(e);
      }
    };

    setLoading(true);

    if (initialItemId) {
      setItem(null);
      loadItem();
    } else {
      setItem(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialItemId]);

  useEffect(() => {
    if (item && item.release_forms.length > 0) {
      const { release_forms, ...rest } = item;
      setSelectedProduct({
        ...rest,
        ...item.release_forms[0],
        _id: rest.id,
      });
    } else {
      setSelectedProduct(null);
    }
  }, [item]);

  const changeGroup = id => {
    const selected = _find(item.release_forms, el => el.id === id);
    const { release_forms, ...rest } = item;

    if (selected) {
      setSelectedProduct({
        ...rest,
        ...selected,
        _id: rest.id,
      });
    }
  };

  return item !== null ? (
    <S.Wrapper>
      <S.InnerWrapper>
        <S.Header>
          <S.Title>{item[`name_${language}`]}</S.Title>
        </S.Header>
        <S.Content>
          <S.ImgCol>
            <S.Photo>
              <S.LabelsContainer>
                {selectedProduct?.in_medication_program ? (
                  <Label.Normal msgTitle="Доступні ліки" msgText="">
                    Доступні ліки
                  </Label.Normal>
                ) : null}
                {selectedProduct?.is_recipe ? (
                  <Label.Important
                    msgTitle={t('labels.only_by_recipe')}
                    msgText=""
                  >
                    {t('labels.only_by_recipe')}
                  </Label.Important>
                ) : null}
              </S.LabelsContainer>

              <img
                src={
                  selectedProduct && selectedProduct.image_url.length
                    ? `${selectedProduct.image_url}?w=400&h=400&q=80`
                    : '/assets/images/no_photo.jpg'
                }
                alt={
                  selectedProduct && selectedProduct.image_url.length
                    ? selectedProduct.name
                    : t('labels.no_photo')
                }
              />
            </S.Photo>
          </S.ImgCol>
          <S.Col>
            <S.Details>
              <S.Line>
                <S.Capt>{t('labels.producer')}</S.Capt>
                <S.Producer>
                  <CountryFlag code={item.goods_producer.country_code} />{' '}
                  {item.goods_producer.name}
                </S.Producer>
              </S.Line>
              {item.release_forms.length ? (
                <>
                  <S.Line className="no-margin">
                    <S.Capt>{t('labels.release_form')}</S.Capt>
                    {item.release_forms.length > 3 ? (
                      <FormDropdown item={item} changeGroup={changeGroup} />
                    ) : (
                      <FormButtons item={item} changeGroup={changeGroup} />
                    )}
                  </S.Line>
                  <Volume />
                </>
              ) : null}
              <S.Line>
                <S.Capt>{t('labels.price')}</S.Capt>
                {!isLoading && selectedProduct != null ? (
                  <>
                    <S.Price>
                      {selectedProduct.online_price ===
                      selectedProduct.drugstore_price ? (
                        <>{selectedProduct.online_price.toFixed(2)} ₴</>
                      ) : (
                        <>
                          {selectedProduct.online_price.toFixed(2)} ₴ -{' '}
                          {selectedProduct.drugstore_price.toFixed(2)} ₴
                        </>
                      )}
                    </S.Price>
                    <S.Hint>
                      {t('labels.the_price_depends_on_the_selected_pharmacy')}
                    </S.Hint>
                  </>
                ) : (
                  <Spinner />
                )}
              </S.Line>
            </S.Details>
          </S.Col>
        </S.Content>
      </S.InnerWrapper>
    </S.Wrapper>
  ) : (
    <Spinner />
  );
};

export default Single;
